module.exports = __webpack_public_path__ + "static/automatic-ai_1-f62093f8616193a00ad2bdd75b788242.jpg";